import { VStack, Dialog, Icon, Button } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';

interface ConfirmationDialogProps {
  description: string;
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { t } = useTranslation('common');
  const { isOpen, title, description, onClose, onConfirm } = props;
  return (
    <Dialog
      open={isOpen}
      Icon={<Icon.AlertTriangle size="large" color="#ffae00" />}
      description={description}
      title={title}
      onClose={onClose}
    >
      <VStack gap={16} width={'100%'}>
        <Button
          variant="primary"
          onClick={() => {
            onConfirm();
            onClose();
          }}
          fullWidth
        >
          {t('yes')}
        </Button>
        <Button variant="outlined" fullWidth onClick={onClose}>
          {t('no')}
        </Button>
      </VStack>
    </Dialog>
  );
};

export default ConfirmationDialog;
